<template>
  <v-layout align-center justify-center align-content-center>
    <modal
      name="errorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Something went wrong. Please try again. If the error persists, please
        contact support.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('errorModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>
    <modal
      name="errorPrimaryAOModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Cannot find Primary AO. Please verify the TMKClientID. If the
        TMKClientID is correct, please contact support.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('errorPrimaryAOModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>
    <div :class="$vuetify.breakpoint.smAndUp ? 'drop page-spacer' : 'drop'">
      <span v-if="$vuetify.breakpoint.xs">
        <v-layout justify-center align-content-center align-center column>
          <v-icon color="green" size="100">mdi-account</v-icon>
          <v-layout justify-center align-content-center align-center column>
            <v-card-title
              style="color: #00558c; font-weight: bold; text-align: center; font-size: 24px;"
              >Recruiter User Management</v-card-title
            >
            <v-card-subtitle style="text-align: center"
              >Add, Modify, Activate &amp; Inactivate Recruiting Director &amp;
              Recruiter Users</v-card-subtitle
            >
          </v-layout>
        </v-layout> </span
      ><span v-else>
        <v-layout justify-center align-content-center align-center row>
          <v-icon color="green" size="100">mdi-account</v-icon>
          <span>
            <v-card-title
              style="color: #00558c; font-weight: bold; text-align: center; font-size: 26px;"
              >Recruiter User Management</v-card-title
            >
            <v-card-subtitle style="text-align: center"
              >Add, Modify, Activate &amp; Inactivate Recruiting Director &amp;
              Recruiter Users</v-card-subtitle
            >
          </span>
        </v-layout>
      </span>
      <br /><br />
      <span
        :class="
          $vuetify.breakpoint.smAndUp ? 'addressTitle2' : 'addressTitleXS2'
        "
        >AGENCY OWNER: {{ primaryAOName }}
      </span>
      <br /><br />
      <v-data-table
        :headers="headers"
        dense
        :items="wait ? [] : adminUsersFiltered"
        :no-data-text="wait ? 'Please wait...' : 'No Recruiting Users Found.'"
        item-key="FederationID"
        class="elevation-4"
        :loading="wait"
        sort-by="CreatedDate"
        :sort-desc="true"
        mobile-breakpoint="960"
      >
        <template v-slot:[`item.Status`]="{ item }">
          {{ item.Status | status }}
        </template>

        <template v-slot:[`item.UpdatedDate`]="{ item }">
          {{ item.UpdatedDate | mmddyyyy }}
        </template>

        <template v-slot:[`item.CreatedDate`]="{ item }">
          {{ item.CreatedDate | mmddyyyy }}
        </template>

        <template v-slot:[`item.edit`]="{ item }">
          <v-tooltip top color="green" dark v-if="item.IsEditable == true">
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="item.IsEditable == true"
                v-on="on"
                :disabled="wait == true"
                @click="editItem(item)"
                >mdi-lead-pencil</v-icon
              >
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top color="green" dark v-else>
            <template v-slot:activator="{ on }">
              <v-icon v-if="item.IsEditable == false" v-on="on"
                >mdi-account-multiple</v-icon
              >
            </template>
            <span>
              {{
                item.Role.toLowerCase() == "recruiter"
                  ? "Partnership Recruiter (Edit Not Allowed)"
                  : "Partnership Recruiting Director (Edit Not Allowed)"
              }}
            </span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-progress-circular
        indeterminate
        color="green"
        v-if="waitCircle"
        size="50"
        class="waitCircle"
      ></v-progress-circular>
      <br />
      <br />

      <span v-if="$vuetify.breakpoint.xs">
        <v-layout column align-center align-content-center>
          <v-btn
            :disabled="wait == true"
            width="200"
            color="green"
            dark
            class="menuBtn"
            @click.stop="refresh"
            >Refresh</v-btn
          >
          <br />
          <v-btn
            :disabled="wait == true"
            width="200"
            color="green"
            v-if="!hide"
            dark
            class="menuBtn"
            @click.stop="hide = !hide"
            >Hide Failed</v-btn
          >
          <v-btn
            :disabled="wait == true"
            width="200"
            color="green"
            v-if="hide"
            dark
            class="menuBtn"
            @click.stop="hide = !hide"
            >Show Failed</v-btn
          >
          <br />

          <v-btn
            :disabled="wait == true"
            color="green"
            v-if="!hidePartnership"
            dark
            class="menuBtn btn-spacer"
            @click.stop="hidePartnership = !hidePartnership"
            >Hide View Only</v-btn
          >
          <v-btn
            :disabled="wait == true"
            color="green"
            v-if="hidePartnership"
            dark
            class="menuBtn btn-spacer"
            @click.stop="hidePartnership = !hidePartnership"
            >Show View Only</v-btn
          >

          <br />
          <v-btn
            :disabled="wait == true"
            width="200"
            color="green"
            dark
            class="menuBtn"
            @click.stop="gotoCreateUser"
            >Create User</v-btn
          >
          <br /><br /><br /><br /><br />
        </v-layout> </span
      ><span v-else>
        <v-layout justify-end align-content-end align-end>
          <v-btn
            color="green"
            dark
            class="menuBtn"
            @click.stop="refresh"
            :disabled="wait == true"
            >Refresh</v-btn
          >
          <v-btn
            :disabled="wait == true"
            color="green"
            v-if="!hide"
            dark
            class="menuBtn btn-spacer"
            @click.stop="hide = !hide"
            >Hide Failed</v-btn
          >
          <v-btn
            :disabled="wait == true"
            color="green"
            v-if="hide"
            dark
            class="menuBtn btn-spacer"
            @click.stop="hide = !hide"
            >Show Failed</v-btn
          >

          <v-btn
            :disabled="wait == true"
            color="green"
            v-if="!hidePartnership"
            dark
            class="menuBtn btn-spacer"
            @click.stop="hidePartnership = !hidePartnership"
            >Hide View Only</v-btn
          >
          <v-btn
            :disabled="wait == true"
            color="green"
            v-if="hidePartnership"
            dark
            class="menuBtn btn-spacer"
            @click.stop="hidePartnership = !hidePartnership"
            >Show View Only</v-btn
          >

          <v-btn
            color="green"
            :disabled="wait == true"
            dark
            class="menuBtn btn-spacer"
            @click.stop="gotoCreateUser"
            >Create User</v-btn
          >
        </v-layout>
        <br /><br /><br /><br /><br /><br />
      </span>
    </div>
  </v-layout>
</template>
<script>
import EventBus from "@/eventBus.js";
import utilityMixins from "@/utility-mixins.js";
import { HTTP_LND } from "@/http-common.js";

export default {
  mixins: [utilityMixins],
  computed: {
    primaryAOName() {
      if (this.primaryAO == null || this.primaryAO.FirstName == undefined) {
        return "";
      }

      return (
        (this.primaryAO.FirstName + " " + this.primaryAO.MiddleName).trim() +
        " " +
        this.primaryAO.LastName
      ).trim();
    },
    modalWidth() {
      return this.$vuetify.breakpoint.xs ? "300" : "450";
    },
    modalHeight() {
      return this.$vuetify.breakpoint.xs ? "225" : "200";
    },
    adminUsersFiltered() {
      var filtered = this.adminUsers;

      if (this.hide) {
        filtered = filtered.filter(au => au.Status != "F");
      }

      if (this.hidePartnership) {
        filtered = filtered.filter(au => au.IsEditable == true);
      }

      return filtered;
    },
    calcWidth() {
      return window.innerWidth - 200;
    },
    tmkClientId() {
      return window.sessionStorage.getItem("tmkClientId");
    }
  },
  created() {
    this.wait = true;
    if (
      this.tmkClientId == null ||
      this.tmkClientId == undefined ||
      this.tmkClientId == ""
    ) {
      this.$router.push("/unauthenticated");
    } else {
      this.makeAxiosCall();
    }
  },
  mounted() {
    EventBus.$on(
      "closeCreateUser",
      function() {
        this.dialog = false;
      }.bind(this)
    );
  },
  beforeDestroy() {
    EventBus.$off("closeCreateUser");
    EventBus.$off("userChange");
  },
  data() {
    return {
      agencyCodes: "",
      primaryAO: {},
      hide: false,
      hidePartnership: false,
      search: null,
      dialog: false,
      waitCircle: false,
      wait: true,
      firstName: "",
      middleName: "",
      lastName: "",
      address: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      phone: "",
      email: "",
      adminUsers: [
        // {
        //   FederationID: "TestUser@globe.life",
        //   FirstName: "Test",
        //   LastName: "User",
        //   Status: "A",
        //   Role: "Recruiting Director",
        //   Manager: "Test Manager",
        //   CreatedDate: Date.now(),
        //   UpdatedDate: Date.now(),
        //   AddressLine1: "123 Main Street",
        //   City: "McKinney",
        //   StateProvinceCode: "TX",
        //   PostalCode: "99999-9999",
        //   PhoneNum: "555-555-5555",
        //   Email: "TestUser@globe.life",
        //   ISOCountryCode: "United States of America"
        // }
      ],
      headers: [
        {
          text: "Email",
          value: "FederationID",
          sortable: true
        },
        {
          text: "First Name",
          value: "FirstName",
          sortable: true
        },
        {
          text: "Last Name",
          value: "LastName",
          sortable: true
        },
        {
          text: "Status",
          value: "Status",
          sortable: true
        },
        {
          text: "Title",
          value: "Role",
          sortable: true
        },
        {
          text: "Manager",
          value: "Manager",
          sortable: true
        },
        {
          text: "Agency Office Number",
          value: "AgencyCode",
          sortable: true
        },
        {
          text: "Created On",
          value: "CreatedDate",
          sortable: true
        },
        {
          text: "Last Updated",
          value: "UpdatedDate",
          sortable: true
        },

        { text: "Edit", value: "edit", sortable: false }
      ]
    };
  },
  methods: {
    checkForEdit(item) {
      var itemFound = item.Accesses.find(
        x => x.PartnershipDescription == "External AO"
      );
      if (itemFound != null) {
        return false;
      }
      return true;
    },
    makeAxiosCall() {
      let self = this;
      this.wait = true;
      this.waitCircle = true;

      HTTP_LND.post("GetPrimaryAO", {
        tmkClientId: this.tmkClientId
      })
        .then(results => {
          if (results.status == 200) {
            self.primaryAO = results.data;
            if (
              self.primaryAO == undefined ||
              self.primaryAO == null ||
              self.primaryAO == ""
            ) {
              self.$modal.show("errorPrimaryAOModal");
              return;
            }
            //get data for the grid
            HTTP_LND.get("getprimaryaoagents", {
              params: {
                PrimaryAOAgentNumber: self.primaryAO.AgentNum
              }
            })
              .then(results => {
                if (results.status == 200) {
                  self.adminUsers = results.data;
                  self.adminUsers.forEach(element => {
                    self.agencyCodes = "";
                    if (element.Accesses.length == 1) {
                      self.agencyCodes = element.Accesses[0].AgencyCode;
                      self.partnershipDescription =
                        element.Accesses[0].PartnershipDescription;
                    } else {
                      element.Accesses.forEach(access => {
                        if (self.agencyCodes.indexOf(access.AgencyCode) < 0) {
                          self.agencyCodes += access.AgencyCode + ",";
                        }
                      });
                    }
                    if (self.agencyCodes.endsWith(",")) {
                      self.agencyCodes = self.agencyCodes.slice(0, -1);
                    }
                    element.AgencyCode = self.agencyCodes;
                    element.IsEditable = self.checkForEdit(element);
                  });
                  self.wait = false;
                  self.waitCircle = false;
                } else {
                  self.waitCircle = false;
                  self.$modal.show("errorModal");
                }
              })
              .catch(e => {
                self.wait = false;
                self.waitCircle = false;
                self.$modal.show("errorModal");
                self.addToErrorLogs(
                  "UserManagement.vue mounted ReadAgentAdmin",
                  e
                );
              });
          }
        })
        .catch(e => {
          self.addToErrorLogs("LNRecruitingHome created makeAxiosCall", e);
          self.wait = false;
          self.waitCircle = false;
        });

      // this.wait = true;
      // HTTP_GAP.get("ReadAgentAdmin", {
      //   params: {
      //     AssociatedAgentTMKClientID: window.sessionStorage.getItem(
      //       "tmkClientId"
      //     ),
      //   },
      // })
      //   .then((results) => {
      //     if (results.status == 200) {
      //       this.adminUsers = results.data;
      //       this.wait = false;
      //     } else {
      //       this.waitCircle = false;
      //       this.$modal.show("errorModal");
      //     }
      //   })
      //   .catch((e) => {
      //     this.wait = false;
      //     this.$modal.show("errorModal");
      //     this.addToErrorLogs("UserManagement.vue mounted ReadAgentAdmin", e);
      //   });
    },
    refresh() {
      if (
        !window.sessionStorage.getItem("tmkClientId") ||
        window.sessionStorage.getItem("tmkClientId") == ""
      ) {
        return false;
      } else {
        this.makeAxiosCall();
      }

      // this.wait = true;
      // this.adminUsers = [];

      // HTTP_GAP.get("ReadAgentAdmin", {
      //   params: {
      //     AssociatedAgentTMKClientID: window.sessionStorage.getItem(
      //       "tmkClientId"
      //     ),
      //   },
      // })
      //   .then((results) => {
      //     if (results.status == 200) {
      //       this.adminUsers = results.data;
      //       this.wait = false;
      //     } else {
      //       this.waitCircle = false;
      //       this.$modal.show("errorModal");
      //     }
      //   })
      //   .catch((e) => {
      //     this.wait = false;
      //     this.$modal.show("errorModal");

      //     this.addToErrorLogs("UserManagement.vue refresh ReadAgentAdmin", e);
      //   });
    },
    Status(agentStatus) {
      switch (agentStatus) {
        case "A":
          return "Active";
        case "I":
          return "Inactive";
        case "F":
          return "Failed";
        case "P":
          return "Pending";
        default:
          return "Unknown";
      }
    },
    editItem(item) {
      let edit = item;
      this.$router.push({
        name: "RecruitingUser",
        params: {
          user: edit,
          mode: "Update",
          primaryAO: this.primaryAO
        }
      });
      // this.waitCircle = true;

      // HTTP_GAP.get("ReadIndividual", {
      //   params: {
      //     AssociatedAgentTMKClientID: window.sessionStorage.getItem(
      //       "tmkClientId"
      //     ),
      //     FederationID: item.FederationID,
      //   },
      // })
      //   .then((results) => {
      //     if (results.status == 200) {
      //       edit = results.data[0];
      //       this.waitCircle = false;
      //       this.$router.push({
      //         name: "User",
      //         params: {
      //           user: edit,
      //           mode: "Update",
      //         },
      //       });
      //     } else {
      //       this.waitCircle = false;
      //       this.$modal.show("errorModal");
      //     }
      //   })
      //   .catch((e) => {
      //     this.waitCircle = false;
      //     this.$modal.show("errorModal");

      //     this.addToErrorLogs("UserManagement.vue editItem ReadIndividual", e);
      //   });
    },
    gotoCreateUser() {
      // this.dialog = true;
      this.$router.push({
        name: "RecruitingUser",
        params: {
          user: null,
          mode: "Create",
          primaryAO: this.primaryAO
        }
      });
    }
  }
};
</script>
<style scoped>
.drop {
  margin-top: 75px;
  position: relative;
  overflow: hidden;
  min-height: 700px;
}
.page-spacer {
  margin-left: 50px;
  margin-right: 50px;
}
.waitCircle {
  z-index: 50;
  position: absolute;
  top: 25%;
  left: 47%;
}
.addressTitle2 {
  color: green;
  font-size: 1.25rem;
  font-weight: bold;

  padding-top: 20px;
}
.addressTitleXS2 {
  color: green;
  font-size: 0.75rem;
  font-weight: bold;
  padding-top: 20px;
  padding-left: 20px;
}
</style>
<style>
.v-data-table-header-mobile__wrapper {
  margin-left: 50px;
}
.btn-spacer {
  margin-left: 10px;
}
</style>
